import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import RenderIf from '../../../shared/render-if/components/render-if';
import constants from '../../../../common/constants';
import paymentMethodsConstants from '../constants/payment-methods-constants';
import PaymentMethodsHelpers from '../helpers/payment-methods-helpers';
import { toggleInfoModal } from '../../../shared/info-modal/actions/info-modal-actions';
import { togglePaymentMethodDetailsModal } from '../actions/payment-method-actions';

import questionMark from '../../../../common/images/question-mark.png';

import '../styles/payment-methods-table.css';

class PaymentMethodsTable extends Component {
  showInfoModal(method) {
    let message = '';
    const { toggleInfoModal } = this.props;

    switch (method.status) {
      case paymentMethodsConstants.statuses.rejected.code:
        message = `PAYMENT_METHOD.PAYMENT_METHOD_REJECTED`;
        break;
      case paymentMethodsConstants.statuses.deleted.code:
        message = 'PAYMENT_METHOD.PAYMENT_METHOD_DELETED';
        break;
      default:
        message = 'PAYMENT_METHOD.PAYMENT_METHOD_APPROVED';
        break;
    }

    toggleInfoModal(true, constants.info_modal_types.info.value, message, { reason: method.reason_message ? method.reason_message : '' });
  }

  showPaymentMethodDetailsModal(method) {
    const { togglePaymentMethodDetailsModal } = this.props;

    togglePaymentMethodDetailsModal(true, method);
  }

  renderPaymentMethods(methods) {
    const { t } = this.context;

    if (methods && methods.length > 0) {
      return methods.map((method, index) => {
        return (
          <div className="payment-methods-table-container__item" key={index}>
            <div className="large-item display-flex-vertical">
              <img src={PaymentMethodsHelpers.getPaymentMethodImage(method.payment_method_type_id)} alt="Payment Method" className="payment-methods-table-container__item__method-img" />
              <div className="payment-methods-table-container__item__name">
                <p className="header">{method.method_type_name}</p>
                <p className="text">{method.custom_name}</p>
              </div>
            </div>
            <div className="large-item payment-methods-table-container__item__name">
              <p className={`header ${method.status === paymentMethodsConstants.statuses.approved.code ? 'approved' : 'not-approved'}`}>
                {t(PaymentMethodsHelpers.getPaymentMethodStatus(method.status, true))}
                <RenderIf if={method.status !== paymentMethodsConstants.statuses.approved.code}>
                  <img
                    src={questionMark}
                    className="question-mark"
                    alt="Qustion Mark"
                    onClick={() => {
                      this.showInfoModal(method);
                    }}
                  />
                </RenderIf>
              </p>
              <p className={`text ${method.status === paymentMethodsConstants.statuses.approved.code ? 'approved' : 'not-approved'}`}>
                {t(PaymentMethodsHelpers.getPaymentMethodStatus(method.status, false))}
              </p>
            </div>
            <div className="small-item">
              <div className="transparent-btn" onClick={() => this.showPaymentMethodDetailsModal(method)}>
                {t('COMMON.MORE_DETAILS')}
              </div>
            </div>
          </div>
        );
      });
    } else return null;
  }

  render() {
    const { paymentMethods } = this.props;

    return <div className="payment-methods-table-container">{this.renderPaymentMethods(paymentMethods)}</div>;
  }
}

const mapStateToProps = state => ({
  paymentMethods: state.paymentMethodsReducer.paymentMethods,
});

const mapDispatchToProps = dispatch => ({
  toggleInfoModal: (show, type, message, translations, callback, path, btnText) => {
    dispatch(toggleInfoModal(show, type, message, translations, callback, path, btnText));
  },
  togglePaymentMethodDetailsModal: (show, method) => {
    dispatch(togglePaymentMethodDetailsModal(show, method));
  },
});

PaymentMethodsTable.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethodsTable);



// WEBPACK FOOTER //
// ./src/app/main/payment-methods/components/payment-methods-table.js